import { useMemo } from "react"
import { ResultType } from "~/react/components/multi_domain_search/result"

export const useSplittedResults = (results: ResultType[]) => {
  const allPeopleResults = useMemo(
    () => results.filter((result) => result.type === "personal"),
    [results],
  )
  const decisionMakersResults = useMemo(
    () =>
      results.filter(
        (result) => result.type === "personal" && result.decisionMaker,
      ),
    [results],
  )
  const genericResults = useMemo(
    () => results.filter((result) => result.type === "generic"),
    [results],
  )

  return { allPeopleResults, decisionMakersResults, genericResults }
}
